import { render, staticRenderFns } from "./audiolist.vue?vue&type=template&id=a9d9b972&scoped=true&"
import script from "./audiolist.vue?vue&type=script&lang=js&"
export * from "./audiolist.vue?vue&type=script&lang=js&"
import style0 from "./audiolist.vue?vue&type=style&index=0&id=a9d9b972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d9b972",
  null
  
)

export default component.exports